module.exports = __webpack_public_path__ + "static/media/tex-gyre-adventor-bold.c1742494.woff";